import styled from "@emotion/styled";
import usePersistParams from "custom-hooks/usePersistParams.hook";
import { useRouter } from "next/router";
function Banners() {
  const router = useRouter();
    // const hasReferer = router.asPath.includes("areferer") || router.asPath.includes("referer") 
  return (
    <div></div>
    // <ContentBanner>
    //   <div className="b"></div>
    //   <div className="w"></div>
    //   <a
    //     href={
    //       hasReferer
    //         ? undefined
    //         : "https://hazlatuya.remaxrd.com/?utm_source=paginaremax&utm_medium=banner&utm_campaign=Remaxrd"
    //     }
    //   >
    //     <img
    //       src={
    //         hasReferer
    //           ? "/images/news/banner_feria-4-sin-botton.png"
    //           : "/images/news/banner_feria-4.png"
    //       }
    //     />
    //   </a>
    // </ContentBanner>
  );
}

export default Banners;

const ContentBanner = styled.div`
  display: flex;
  width: 100%;
  height: 4rem;
  & > div {
    width: 50%;
    height: 4rem;
  }
  .b {
    background-color: #13408d;
  }
  .w {
    background-color: white;
  }
  a {
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 4rem;
  }
  img {
    object-fit: contain;
    width: 100%;
    height: 4rem;
  }

  @media (max-width: 768px) {
    display: flex;
    width: 100%;
    height: auto;
    & > div {
      width: 50%;
      height: auto;
    }
    a {
      position: absolute;
      z-index: 1;
      width: 100%;
      height: auto;
    }
    img {
      object-fit: contain;
      width: 100%;
      height: auto;
    }
  }
`;

